import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Card from '../../components/_molecules/Card';
import { StyledCostsSolution } from './CostsSolution.styled';
import { CONSTS_SOLUTION_DATA } from './costsSolutionData';

const CostsSolution: FC = () => {
  const { t } = useTranslation();

  return (
    <StyledCostsSolution className="cedolauto-costs-solution-section">
      <p className="cedolauto-costs-solution-section__subtitle">
        {t('section_4-header')}
      </p>

      <div className="cedolauto-costs-solution-section__cards">
        {CONSTS_SOLUTION_DATA.map(({ title, ...rest }) => (
          <Card
            type="criteria"
            showChecks={false}
            key={title}
            title={title}
            {...rest}
          />
        ))}
      </div>

      <p className="cedolauto-costs-solution-section__subtitle">
        {t('section_4-subtext')}
      </p>
    </StyledCostsSolution>
  );
};

export default CostsSolution;
